import { render } from "./instructor-recommendation.vue?vue&type=template&id=596a4b10"
import script from "./instructor-recommendation.vue?vue&type=script&lang=js"
export * from "./instructor-recommendation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__